// extracted by mini-css-extract-plugin
module.exports = {"flex":"Email_flex_21liK","input":"Email_input_O8syJ","comment":"Email_comment_3drjV","message":"Email_message_31gfn","btn":"Email_btn_26HcN","bdr":"Email_bdr_mqXSt"};